import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New design variables introduced 11-12-2019 */

    /* New design variables introduced 7-16-2020 */
}
:root {
    @lost gutter 24px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    @custom-media --small-up (min-width: 322px);
    @custom-media --small-down (max-width: 320px);
    @custom-media --small-only (max-width: 320px);

    @custom-media --medium-up (min-width: 722px);
    @custom-media --medium-down (max-width: 720px);
    @custom-media --medium-only (max-width: 720px) and (min-width: 321.001);

    @custom-media --large-up (min-width: 1082px);
    @custom-media --large-down (max-width: 1080px);
    @custom-media --large-only (max-width: 1080px) and (min-width: 721.001);

    @custom-media --xlarge-up (min-width: 1442px);
    @custom-media --xlarge-down (max-width: 1440px);
    @custom-media --xlarge-only (max-width: 1440px) and (min-width: 1081.001);

    @custom-media --xxlarge-up (min-width: 1922px);
    @custom-media --xxlarge-down (max-width: 1920px);
    @custom-media --xxlarge-only (max-width: 1920px) and (min-width: 1441.001);

    @custom-media --small-up-height (min-height: 322px);
    @custom-media --small-down-height (max-height: 320px);
    @custom-media --small-only-height (max-height: 320px);

    @custom-media --medium-up-height (min-height: 722px);
    @custom-media --medium-down-height (max-height: 720px);
    @custom-media --medium-only-height (max-height: 720px) and (min-height: 321.001);

    @custom-media --large-up-height (min-height: 1082px);
    @custom-media --large-down-height (max-height: 1080px);
    @custom-media --large-only-height (max-height: 1080px) and (min-height: 721.001);

    @custom-media --xlarge-up-height (min-height: 1442px);
    @custom-media --xlarge-down-height (max-height: 1440px);
    @custom-media --xlarge-only-height (max-height: 1440px) and (min-height: 1081.001);

    @custom-media --xxlarge-up-height (min-height: 1922px);
    @custom-media --xxlarge-down-height (max-height: 1920px);
    @custom-media --xxlarge-only-height (max-height: 1920px) and (min-height: 1441.001);
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
button {
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
.input-field {
  position: relative;
  margin-bottom: calc(8px * 6);
  line-height: calc(8px * 2);
}
.input-wrapper {
  position: relative;
  margin-top: 8px;
  margin-bottom: 8px;
}
.field-title {
  color: #3B4B59;
  font-size: 16px;
  display: block;
}
.icon {
  position: absolute;
  right: 8px;
  top: 0px;
  height: 100%;
  display: flex;
  align-items: center;
}
.input-field :global(input) {
  width: 100%;
  font-family: 'Nimbus Sans', sans-serif;
  border: solid 1px #D3D7DA;
  border-radius: 4px;
  color: #3B4B59;
  font-size: 16px;
  line-height: 22px;
  outline: none;
  margin: 8px 0;
  padding: 12px calc(8px * 4)
    12px calc(8px * 2);
  margin-bottom: 0;
  margin-top: 0;
}
.input-field :global(input::-moz-placeholder) {
  color: #b4babf;
}
.input-field :global(input:-ms-input-placeholder) {
  color: #b4babf;
}
.input-field :global(input::placeholder) {
  color: #b4babf;
}
.input-field :global(input[type='checkbox']) {
  width: auto;
}
/* Disable number arrows */
.input-field :global(input:focus) {
  border: solid 1px #00c3e0;
}
.input-field :global(input.disabled) {
  border: solid 1px #b4babf;
  color: #b4babf;
}
.input-field :global(.disabled::-moz-placeholder) {
  color: #6b7880;
}
.input-field :global(.disabled:-ms-input-placeholder) {
  color: #6b7880;
}
.input-field :global(.disabled::placeholder) {
  color: #6b7880;
}
.input-field :global(input.error) {
  border: solid 1px #cc1f1f;
  color: #cc1f1f;
}
.input-field :global(input.success) {
  border: solid 1px #008a00;
  color: #008a00;
}
.input-field :global(input:focus::-moz-placeholder) {
  color: transparent;
}
.input-field :global(input:focus:-ms-input-placeholder) {
  color: transparent;
}
.input-field :global(input:focus::placeholder) {
  color: transparent;
}
.field-title.disabled {
  color: #959fa6;
}
.error-msg {
  color: #cc1f1f;
  position: absolute;
  font-size: 14px;
  line-height: calc(8px * 2);
}
.input-icon {
  width: calc(8px * 2);
  height: calc(8px * 2);
}
label {
  display: flex;
  color: #3B4B59;
}
.title-layout-bottom label {
  flex-direction: column-reverse;
}
.title-layout-top label {
  flex-direction: column;
}
.title-layout-left label,
.title-layout-right label {
  align-items: center;
}
.title-layout-left .input-wrapper {
  padding-left: calc(8px * 2);
}
.title-layout-right .input-wrapper {
  padding-right: calc(8px * 2);
}
.title-layout-left label {
  flex-direction: row;
}
.title-layout-right label {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
`;

export default styles;